import { render, staticRenderFns } from "./NoMealPersons.vue?vue&type=template&id=1ec75d3b&scoped=true&"
import script from "./NoMealPersons.vue?vue&type=script&lang=js&"
export * from "./NoMealPersons.vue?vue&type=script&lang=js&"
import style0 from "./NoMealPersons.vue?vue&type=style&index=0&id=1ec75d3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec75d3b",
  null
  
)

export default component.exports